import {
  helpers,
  required,
  minLength,
  maxLength,
  numeric,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import config from "@/config";

const maxRows = parseInt(config.get("customerReturnMaxSize"), 10) || 500;

const countValidation = {
  required,
  numeric,
  minValue: minValue(1),
  maxValue: maxValue(maxRows),
  maxLength: maxLength(maxRows.toString().length),
};

export const productValidationWithoutProductCategory = {
  sku: { required },
  count: countValidation,
  returnReason: { required },
  problemOccurence: { required },
  additionalInformation: { maxLength: maxLength(250) },
  serials: {
    $each: {
      minLength: minLength(4),
      // @ts-expect-error Helpers does contain regex
      mustContainNumber: helpers.regex("alpha", /^.*\d.*$/),
      // @ts-expect-error Helpers does contain regex
      mustNotContainDots: helpers.regex("alpha", /^[^.]*$/),
    },
  },
};

export const productValidationWithProductCategory = {
  ...productValidationWithoutProductCategory,
  tariffCode: { required },
};
